import React from "react";
import styled from "styled-components";

import SocialIconsFooter from "../components/SocialIconsFooter";
const Footer = ({ location }) => {
  return (
    <Container>
      <Copyright location={location}>
        <p>Copyright © 2021 Hemme.rs</p>
      </Copyright>
      &nbsp;
      <SocialIconsFooter />
    </Container>
  );
};

const Container = styled.footer`
  flex: 1;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  z-index: 100;
  position: fixed;
  left: 7%;
  right: 7%;
  height: 6rem;
  bottom: 0;
  background: #000000;
  overflow: visible;
  border-radius: 10px 10px 0 0;
  box-shadow: 0 5px 20px rgba(255, 255, 255, 0.3);
  @media (max-width: 40rem) {
    height: 4rem;
    padding: 0 5rem;
  }
  @media (max-width: 22.5rem) {
    height: 4rem;
  }
`;

const Copyright = styled.div`
  opacity: 0.5;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  color: #fff;
  margin-top: 1rem;
  justify-content: space-between;
  text-align: center;

  p {
    @media (max-width: 40rem) {
      font-size: 0.7rem;
      margin-top: -0.5rem;
      margin-bottom: -1rem;

      @media (max-width: 22.5rem) {
        font-size: 0.7rem;
      }
    }
  }
`;

export default Footer;
